import { Api } from "../config/request";

export default {
  getTdsCertificates(queryParams) {
    return Api.get(`/driver-accounting/rider-tds-certificates?${queryParams}`);
  },
};
